import React from 'react';
import { Switch, Route } from 'react-router-dom';

import Home from '../pages/Home';

import Terms from '../pages/Terms';

const Routes = () => (
  <Switch>
    <Route path="/" exact component={Home} />
    <Route path="/terms" component={Terms} />
  </Switch>
);

export default Routes;
